import { ProposedShipmentMapDetails } from './ProposedShipmentMapDetails';

export class GetRouteBuilderMapDetailsResponse {
  details: ProposedShipmentMapDetails[];

  constructor(opts: GetRouteBuilderMapDetailsResponse) {
    this.details = opts.details.map((d) => new ProposedShipmentMapDetails(d));
  }
}
